import React, { useCallback, useEffect, useState } from "react";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import TagOrder from "./component";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlreadyScanned from "./AlreadyScanned";
import { useDispatch, useSelector } from "react-redux";
import { useWebSocket } from "../../Websocket/useWebSocket";
import { setWebSocketData } from "../../Websocket/webSocketAction";
import PaymentStatus from "./PaymentStatus/Component";
import CouponList from "./buyOrder/CouponList";
import { Box } from "@material-ui/core";
import ApplyCouponPopUp from "./ApplyCouponPopUp";
import backArrow from "../../assets/backArrow.png";
import NoCoupons from "./NoCoupon";
import DaalchiniLogo from "../../assets/dalchini_icon.png";
import NoInternet from "../../NoInterNet/component";
import ServerErrorPage from "../../ServerError/ServerErrorPage";

// ─── Import your two error screens ───────────────────────────────────────────
// Replace these with your actual paths
import OrderNotFound from "../../Components/TagOrder/OrderNotFound";   // "Order Not Found" screen
import logger from "../../Utils/logger";
// import ServerErrorPage already imported above

const TagOrderContainer = () => {
  const location  = useLocation();
  const navigate  = useNavigate();
  const dispatch  = useDispatch();

  const ReduxOrderData = useSelector((state) => state.WebSocket?.OrderData);
  const { makeApiRequest } = useApiRequest();
  const { wsData, startWebSocket } = useWebSocket();

  // ─── Parse & validate value ONCE ─────────────────────────────────────────
  const params = new URLSearchParams(location.search);
  const str    = params.get("value");
  // Guard: if value is missing, empty, or literally "null" → treat as invalid
  const value  = str?.split("?")?.[0]?.trim() || null;
  const isValidValue = Boolean(value && value !== "null" && value !== "undefined");

  // ─── State ────────────────────────────────────────────────────────────────
  const [paymentStatusFlag,       setPaymentStatusFlag]       = useState(false);
  const [loader,                  setLoader]                  = useState(false);
  const [reward,                  setReward]                  = useState(null);
  const [couponsList,             setCouponsList]             = useState(null);
  const [couponAppliedSuccess,    setCouponAppliedSuccess]    = useState(false);
  const [showCouponPopFlag,       setShowCouponPopFlag]       = useState(false);
  const [orderSucessStatus,       setOrderSucessStatus]       = useState(false);
  const [orderSucessPaymentMethod,setOrderSucessPaymentMethod]= useState(null);
  const [orderSucessOrderId,      setOrderSucessOrderId]      = useState(null);
  const [couponCode,              setCouponCode]              = useState("");
  const [loadingLoyalty,          setLoadingLoyalty]          = useState(true);
  const [loadingCoupon,           setLoadingCoupon]           = useState(true);
  const [machineId,               setMachineId]               = useState(null);
  const [serverError,             setServerError]             = useState(false);
  const [noInternet,              setNoInternet]              = useState(false);
  // NEW: dedicated flag when value itself is invalid / order not found
  const [orderNotFound,           setOrderNotFound]           = useState(false);

  // ─── Early exit: no valid value → skip all API calls, show OrderNotFound ──
  useEffect(() => {
    if (!isValidValue) {
      setOrderNotFound(true);
      setLoadingLoyalty(false);
      setLoadingCoupon(false);
    }
  }, [isValidValue]);

  // ─── Error helpers ────────────────────────────────────────────────────────
  const handleServerError = useCallback((error) => {
    const statusCode = error?.response?.data?.status?.code;
    logger.log("API error status code:", error?.response?.status );
    if (statusCode === "INTERNAL_SERVER_ERROR" || error?.response?.status === 500 || error?.response?.status === 502) {
      setServerError(true);
      setLoader(false);
      return true;
    }
    return false;
  }, []);

  const handleNetworkError = useCallback((err) => {
    logger.log("Network error:", err?.code);
    if (err?.code === "ERR_NETWORK") {
      setNoInternet(true);
      return true;
    }
    return false;
  }, []);

  // ─── API: Fetch Coupon ────────────────────────────────────────────────────
  const fetchCoupon = useCallback(() => {
    // Guard: skip if no valid value
    if (!isValidValue) return;

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId    = localStorage.getItem("uuid");

    setLoader(true);
    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/kiosk/post-order/coupon?orderId=${value}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      handleSuccess: handleResponseCoupon,
      handleError: handleErrorCoupon,
    });
  }, [isValidValue, value]);

  const handleResponseCoupon = (res) => {
    setCouponsList(res?.data?.data);
    if (res?.data?.data?.length === 1) {
      document.body.style.background = "none";
    }
    setLoadingCoupon(false);
  };

  const handleErrorCoupon = (err) => {
    setLoadingCoupon(false);
    if (handleServerError(err)) return;
    if (handleNetworkError(err)) return;
    // If order id not recognised by coupon API → order not found
 /*    const code = err?.response?.data?.status?.code;
    if (code === "NOT_FOUND" || err?.response?.status === 404) {
      setOrderNotFound(true);
    } */
  };

  // ─── API: Fetch Loyalty ───────────────────────────────────────────────────
  const fetchLoyalty = useCallback(() => {
    // Guard: skip if no valid value
    if (!isValidValue) return;

    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId    = localStorage.getItem("uuid");

    setLoader(true);
    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/user/loyalty/${value}/tag`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: {},
      handleSuccess: handleResponseLoyalty,
      handleError: handleErrorLoyalty,
    });
  }, [isValidValue, value]);

  const handleResponseLoyalty = (res) => {
    setLoader(false);
    setReward(res?.data?.data);
    setMachineId(res?.data?.data?.machineId);
    setLoadingLoyalty(false);
  };

  const handleErrorLoyalty = (err) => {
    setReward(false);
    setLoadingLoyalty(false);
    setLoader(false);

    if (handleServerError(err)) return;
    if (handleNetworkError(err)) return;

    const code = err?.response?.data?.status?.code;
        logger.log("Coupon API error:", err?.response?.data?.status);
 const message = err?.response?.data?.status?.message?.toLowerCase() || "";
if (        message.includes("order not found")  // ← your API's message field
) {
  setOrderNotFound(true);
}

    if (code === "UNAUTHORIZED" || code === "ACCESS_DENIED") {
      navigate(`/login?route=tagOrderId?value=${value}`, 
        {
        state: { from: location.pathname + location.search },
      });
      return;
    }

    // Order not found on loyalty side as well
    if (code === "NOT_FOUND" || err?.response?.status === 404) {
      setOrderNotFound(true);
    }
  };

  // ─── API: Apply Coupon ────────────────────────────────────────────────────
  const ApplyCoupon = (id, name) => {
    setCouponCode(name);
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId    = localStorage.getItem("uuid");

    setLoader(true);
    makeApiRequest({
      url: `${process.env.REACT_APP_API_BASE_URL}/consumerbe/api/v2/kiosk/post-order/coupon`,
      method: "POST",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
      },
      data: { couponId: id, orderId: value },
      handleSuccess: handleResponseApplyCoupon,
      handleError: handleErrorApplyCoupon,
    });
  };

  const handleResponseApplyCoupon = () => {
    setLoader(false);
    setCouponAppliedSuccess(true);
  };

  const handleErrorApplyCoupon = (error) => {
    setCouponAppliedSuccess(false);
    setShowCouponPopFlag(true);
    setLoader(false);
    if (handleNetworkError(error)) return;
  };

  // ─── useEffect: fire APIs only when value is valid ────────────────────────
  useEffect(() => {
    if (!isValidValue) return;   // ← KEY GUARD: no value → no API calls
    fetchLoyalty();
    fetchCoupon();
  }, [value]);                   // re-runs only when value actually changes

  // ─── WebSocket ────────────────────────────────────────────────────────────
  const handleStartWebSocket = (orderId) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/consumerbe/status/payment?order_id=${orderId}`;
    startWebSocket(url, (data) => {
      dispatch(setWebSocketData(data));
      setPaymentStatusFlag(true);
      setOrderSucessStatus(data?.success);
      setOrderSucessOrderId(data?.orderId);
      setOrderSucessPaymentMethod(data?.pgName);
      setLoader(false);
    });
  };

  // ─── Coupon helpers ───────────────────────────────────────────────────────
  const handleCloseCouponPopup = () => {
    setCouponAppliedSuccess(false);
    setShowCouponPopFlag(false);
  };

  const applyCoupon = (e, id, name) => ApplyCoupon(id, name);

  const CouponText = () => (
    <>
      {couponAppliedSuccess && <p>Your coupon Claimed successfully!</p>}
      {showCouponPopFlag    && <p>Something went wrong. Please try again later</p>}
    </>
  );

  // ─── Header ───────────────────────────────────────────────────────────────
  const MyHeader = ({ handleBack }) => (
    <Box
      display="flex"
      alignItems="center"
      p={2}
      sx={{ background: "#fae14b", position: "fixed", width: "100%", zIndex: 999 }}
    >
      <Box
        component="img"
        src={backArrow}
        alt="Back"
        sx={{ width: 22, height: 18, ml: 1 }}
        onClick={handleBack}
      />
      <Box
        component="img"
        src={DaalchiniLogo}
        alt="Logo"
        sx={{ width: 100, height: 40, ml: 1 }}
      />
    </Box>
  );

  const handleBack             = () => navigate("/");
  const RedirectAfterPaymentStatus = () => navigate(`/pickupOptions/${ReduxOrderData.orderId}`);

  // ─── Render guards (priority order) ──────────────────────────────────────

  // 1. No valid value in URL → Order Not Found immediately, no loader
  if (orderNotFound) return <OrderNotFound />;

  // 2. Server error
  if (serverError) return <ServerErrorPage />;

  // 3. No internet
  if (noInternet) return <NoInternet />;

  // 4. Both APIs still loading
  const isLoading = loadingLoyalty || loadingCoupon;
  if (isLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3>Loading...</h3>
      </div>
    );
  }

  // 5. Both APIs done but no reward AND no coupons → already scanned
  if (reward === false && (!couponsList || couponsList.length === 0)) {
    return <AlreadyScanned />;
  }

  // ─── Main render ──────────────────────────────────────────────────────────
  return (
    <>
      <MyHeader handleBack={handleBack} />

      {/* Coupon pop-up (error or success) */}
      {(showCouponPopFlag || couponAppliedSuccess) && (
        <ApplyCouponPopUp
          CouponText={CouponText}
          handleCloseCouponPopup={handleCloseCouponPopup}
          couponAppliedSuccess={couponAppliedSuccess}
          machineId={machineId}
        />
      )}

      {reward ? (
        <>
          {paymentStatusFlag ? (
            <PaymentStatus
              onTimerComplete={RedirectAfterPaymentStatus}
              status={setOrderSucessStatus}
              amount="100"
              orderId={orderSucessOrderId}
              paymentMethod={orderSucessPaymentMethod}
            />
          ) : (
            <TagOrder
              loader={loader}
              reward={reward}
              couponsList={couponsList}
              applyCoupon={applyCoupon}
              couponAppliedSuccess={couponAppliedSuccess}
              showCouponPopFlag={showCouponPopFlag}
              handleCloseCouponPopup={handleCloseCouponPopup}
              CouponText={CouponText}
              handleStartWebSocket={handleStartWebSocket}
              setPaymentStatusFlag={setPaymentStatusFlag}
              paymentStatusFlag={paymentStatusFlag}
              machineId={machineId}
            />
          )}
        </>
      ) : (
        <>
          {couponsList?.length > 0 ? (
            <Box sx={{ p: "20px", background: "white" }}>
              <CouponList
                couponsList={couponsList}
                applyCoupon={applyCoupon}
                marginTop="50px"
                reward={reward}
              />
            </Box>
          ) : (
            <NoCoupons machineId={machineId} />
          )}
        </>
      )}
    </>
  );
};

export default TagOrderContainer;